import { Overlay } from '@angular/cdk/overlay';
import { Output } from '@angular/core';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { Tempo } from '../models/tempo';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';
import { MapConfig } from '../models/map-config';
import { HeatmapType } from '../models/heatmap-type';

/**
 * Este componente exibe uma lista das estações que apresentaram um dado padrão
 * de intensidades nos acumulados de chuva, e os horários em que esses padrões
 * foram registrados.
 */
@Component({
  selector: 'app-datelist',
  templateUrl: './datelist.component.html',
  styleUrls: ['./datelist.component.css']
})
export class DatelistComponent implements OnInit {


  dateList : any[] = []
  dateListPage: any[] = [];
  @Output() searchDate = new EventEmitter<any[]>();
  lastDate : any;
  lastEndDate: any;
  visible:boolean = false
  station_name: string;
  last_date_string :string; 
  last_date_id :number;
  @Output() changedview = new EventEmitter<boolean>()
  @Output() eventsHeatmapLayerToggled = new EventEmitter<null>();

  pageIndex: number = 0;
  pageSize: number = 4;
  pageSizeOptions: number[] = [4,6,8,10,12];

  formattedText : string[] = []

  /** Instância da configuração do mapa na tela da análise instantânea. */
  mapConfig: MapConfig = this.mapConfigService.instantMapConfig;

  constructor(private mapConfigService: MapConfigService) { }

  ngOnInit(): void {
  }

  /**
   * Atualiza a lista dos horários que as estações apresentaram um dado padrão de 
   * intensidades de chuvas, ordenada pelo número de ocorrências registradas no horário.
   * @param result [nome da estação na linha selecionada na heatmatrix, lista de outras estações que apresentaram o padrão em outros horários]
   * @returns 
   */
  updateList(result:[string, any[]]): void{
    this.dateList = result[1]
    this.lastDate = this.mapConfig.time.tempo[0];
    this.lastEndDate = this.mapConfig.time.tempo[1];
    this.formattedText = []
    if (this.dateList.length == 0) {
      return;
    }
    for (let i =0; i<5; i++){

      if (this.dateList[i] == null) {
        break;
      }
      this.formattedText.push(this.getFormattedText(this.dateList[i]))
    }
    this.resetPaginationParams();
    this.dateListPage = result[1].slice(this.pageIndex, this.pageIndex + this.pageSize);
    this.station_name = result[0]
    let formatedday,formatedhour,formatedmin,formatedmonth
    if (this.lastDate.minuto < 10){formatedmin = "0"+this.lastDate.minuto} else {formatedmin = this.lastDate.minuto}
    if (this.lastDate.hora < 10){formatedhour = "0"+this.lastDate.hora} else {formatedhour = this.lastDate.hora}
    if (this.lastDate.dia < 10){formatedday = "0"+this.lastDate.dia} else {formatedday = this.lastDate.dia}
    if (this.lastDate.mes < 10){formatedmonth = "0"+this.lastDate.mes} else {formatedmonth = this.lastDate.mes}
    this.last_date_string = `Retornar para ${formatedhour}:${formatedmin} - ${formatedday}/${formatedmonth}/${this.lastDate.ano}`
    console.log('update list last date', this.lastDate);
  }

  /** Limpa o conteúdo da datelist */
  erase() {
    this.dateList = []
    this.dateListPage = [];
    // this.lastDate = undefined
    this.station_name = ""
    this.last_date_string = ""
  }

  /**
   * Emite o evento para iniciar uma atualização do mapa para a data selecionada.
   * @param dates 
   */
  searchInDate(dates: any[]){
    console.log({dates}, 'elemento', this.lastDate);
    if (this.lastDate != undefined) {
      this.searchDate.emit(dates);
    }
  }

  /**
   * Retorna para a data anterior àquela selecionada na datelist.
   */
  returnToDate(){
    this.lastDate.id_estacao = this.last_date_id;
    this.searchDate.emit([this.lastDate, this.lastEndDate]);
  }

  /**
   * Alterna entre exibir e esconder o componente.
   */
  changeView(){
    if (this.visible){
        this.visible = false
        this.changedview.emit(this.visible)
    } else {
      this.visible = true   
    }
  }

  /**
   * Reinicia os valores do índice dad página e tamanho da página.
   */
  resetPaginationParams() {
    this.pageIndex = 0;
    this.pageSize = 4;
  }

  /**
   * Atualiza o array de registros de tempo para refletir a página selecionada pelo usuário.
   * @param event evento da alteração da página.
   */
  onPageChanged(event: any) {

    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    let start = this.pageIndex * this.pageSize;
    let end = start + this.pageSize;

    this.dateListPage = this.dateList.slice(start, end);
    this.formattedText= []
    this.dateListPage.forEach( (val)=>{
      this.formattedText.push(this.getFormattedText(val))
    })
  }

  /**
   * Cria uma string com o nome da estação e o horário da medição que 
   * apresentou o padrão das intensidades.
   * @param val objeto que tem o nome da estação e o horário da medição.
   * @returns string 'estação - horário'
   */
  getFormattedText(val : any):string{
    let formattedText,formatedmin,formatedhour,formatedday,formatedmonth

    if (val.minuto < 10){formatedmin = "0"+val.minuto} else {formatedmin = val.minuto}
    if (val.hora < 10){formatedhour = "0"+val.hora} else {formatedhour = val.hora}
    if (val.dia < 10){formatedday = "0"+val.dia} else {formatedday = val.dia}
    if (val.mes < 10){formatedmonth = "0"+val.mes} else {formatedmonth = val.mes}
    formattedText = ` ${val.nome} - ${val.tempo}`

    return formattedText
  }

  /**
   * Trata o botão de ligar / desligar a camada do heatmap das ocorrências.
   */
  toggleEventsHeatmapLayer() {
    let list = this.mapConfig.layer.list[HeatmapType.EVENTS_HEATMAP];
    list.isActive = !list.isActive;
    this.eventsHeatmapLayerToggled.emit();
  }

}
